import { Button, Card, Inline, Stack, Text } from '@etg/wings';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Link, useLocation } from 'react-router-dom';
import { routes } from '../../../../../constants/routesAndApisConstants';
import TitledCard from '../../../../../common/components/TitledCard';
import DocumentLinks from '../../common/DocumentLinks';

const cardSectionStyles = css`
  margin: 0;
  padding-inline: 0;
`;

const Documents = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { pathname } = useLocation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const shouldShowRedirectToTravelInformation =
    p('OrderDetails.TravelInformation.Enabled') &&
    !pathname.includes(routes.ORDER_DETAILS_TRAVEL_INFORMATION);

  const handleSnowplowOnTravelInformation = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Overview',
        action: 'Click',
        label: 'TRAVEL_INFORMATION',
      });
    }
  };

  return (
    <>
      <TitledCard data-testid="documents-page-section" title={t('OrderDetails.Documents.Header')}>
        <Card.Section className={cardSectionStyles}>
          <DocumentLinks />
        </Card.Section>
        {shouldShowRedirectToTravelInformation && (
          <Card.Section className={cardSectionStyles} data-testid="documents-card-redirect-section">
            <Stack>
              <Text>{t('OrderDetails.Documents.TravelInformation.Redirect.Description.Text')}</Text>
              <Inline>
                <Button
                  as={Link}
                  data-testid="documents-card-redirect-btn"
                  onClick={handleSnowplowOnTravelInformation}
                  to={routes.ORDER_DETAILS_TRAVEL_INFORMATION}
                >
                  {t('OrderDetails.Tab.TravelInformation.Description')}
                </Button>
              </Inline>
            </Stack>
          </Card.Section>
        )}
      </TitledCard>
    </>
  );
};

export default Documents;
